export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-21-70bba40f2a306c2a45e6c5c936ce280a.jpg";